import React, { ReactNode } from 'react'
import { AutocompleteRenderOptionState } from '@mui/material'
import { highlightSearchTerm } from './highlightSearchTerm'
import { createUnitLabel } from '../../utils/measureHelpers'
import { Unit } from '../../types'

/**
 * Generates a reusable render option function for MUI Autocomplete.
 * @param renderIcon Optional function to render an icon or additional content.
 * @param transformText Optional transformation function for highlighted parts.
 */
export const createAutocompleteRenderOption = <T extends { displayName: string }>(
  renderIcon?: (option: T) => ReactNode,
  transformText?: (part: string, index: number) => ReactNode
) => {
  // eslint-disable-next-line react/display-name
  return (props: any, option: T, state: AutocompleteRenderOptionState): ReactNode => {
    const { inputValue } = state

    // if option is a Unit and not a Measure display through createUnitLabel
    let text = option.displayName
    if ('symbol' in option) {
      text = createUnitLabel(option as unknown as Unit)
    }

    return (
      <li {...props}>
        {renderIcon?.(option)}
        {highlightSearchTerm(text, inputValue, transformText)}
      </li>
    )
  }
}
